export default __webpack_public_path__ + "static/media/404.fab8ad69.png";